import {
  ADD_STEP,
  ADD_STEP_FAILURE,
  ADD_STEP_SUCCESS,
  //
  DELETE_STEP,
  DELETE_STEP_FAILURE,
  DELETE_STEP_SUCCESS,
  //
  EDIT_STEP,
  EDIT_STEP_FAILURE,
  EDIT_STEP_SUCCESS,
  //
  FETCH_STEPS,
  FETCH_STEPS_FAILURE,
  FETCH_STEPS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  TOGGLE_STEP_ADD_MODAL,
  //
  UPDATE_STEP_ORDER,
  UPDATE_STEP_ORDER_SUCCESS,
  UPDATE_STEP_ORDER_FAILURE,
  //
  VALIDATE_DELETE,
  VALIDATE_DELETE_SUCCESS,
  VALIDATE_DELETE_FAILURE,
  //
  TOGGLE_STEP_DELETE_MODAL,
} from "./constants";

// List
export const fetchSteps = (payload, onFetch) => ({
  type: FETCH_STEPS,
  payload,
  onFetch,
});
export const fetchStepsSuccess = (payload) => ({
  type: FETCH_STEPS_SUCCESS,
  payload,
});
export const fetchStepsFailure = (payload) => ({
  type: FETCH_STEPS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addStep = (payload, onSuccess) => ({
  type: ADD_STEP,
  payload,
  onSuccess,
});
export const addStepSuccess = (payload) => ({
  type: ADD_STEP_SUCCESS,
  payload,
});
export const addStepFailure = (payload) => ({
  type: ADD_STEP_FAILURE,
  payload,
});
// EDIT
export const editStep = (payload, onSuccess) => ({
  type: EDIT_STEP,
  payload,
  onSuccess,
});
export const editStepSuccess = (payload) => ({
  type: EDIT_STEP_SUCCESS,
  payload,
});
export const editStepFailure = (payload) => ({
  type: EDIT_STEP_FAILURE,
  payload,
});
// DELETE
export const deleteStep = (payload, onDelete) => ({
  type: DELETE_STEP,
  payload,
  onDelete,
});
export const deleteStepSuccess = (payload) => ({
  type: DELETE_STEP_SUCCESS,
  payload,
});
export const deleteStepFailure = (payload) => ({
  type: DELETE_STEP_FAILURE,
  payload,
});

export const toggleStepAdd = (payload) => ({
  type: TOGGLE_STEP_ADD_MODAL,
  payload,
});

export const updateStepOrder = (payload, onStepUpdate) => ({
  type: UPDATE_STEP_ORDER,
  payload,
  onStepUpdate,
});
export const updateStepOrderSuccess = (payload) => ({
  type: UPDATE_STEP_ORDER_SUCCESS,
  payload,
});
export const updateStepOrderFailure = (payload) => ({
  type: UPDATE_STEP_ORDER_FAILURE,
  payload,
});

export const validateDelete = (payload, callback) => ({
  type: VALIDATE_DELETE,
  payload,
  callback,
});
export const validateDeleteSuccess = (payload) => ({
  type: VALIDATE_DELETE_SUCCESS,
  payload,
});
export const validateDeleteFailure = (payload) => ({
  type: VALIDATE_DELETE_FAILURE,
  payload,
});

export const toggleStepDeleteModal = (payload) => ({
  type: TOGGLE_STEP_DELETE_MODAL,
  payload,
});
